import React from 'react'

import Option from '../../elements/Option'

import { WrapperInstall, List, TextInstall } from './styles'
import { installText, carType } from './data.json'

import IcCarBig from '../../elements/Icon/ic-car-big'
import IcBus from '../../elements/Icon/ic-bus-big'
import IcTruck from '../../elements/Icon/ic-truck-big'
import TruckPDF from '../../../static/truck.pdf'
import CarPDF from '../../../static/car.pdf'
import BusPDF from '../../../static/bus.pdf'

const handleClickDownload = function(path) {
  window.open(path, '_blank')
}

const HowToInstall = props => {
  return (
    <WrapperInstall>
      <TextInstall textWhite={props.textWhite}>{installText}</TextInstall>
      <List>
        <Option
          description={carType.car}
          icon={<IcCarBig />}
          setOption={() => handleClickDownload(CarPDF)}
          value="carro-passeio"
          notGray
          className="gtm-element-event"
          data-gtm-event-category="veloe:area-logado:identificadores"
          data-gtm-event-action="clique:como-instalar"
          data-gtm-event-label="carro-passeio"
        />
        <Option
          description={carType.truck}
          icon={<IcTruck />}
          value="caminhao"
          setOption={() => handleClickDownload(TruckPDF)}
          notGray
          className="gtm-element-event"
          data-gtm-event-category="veloe:area-logado:identificadores"
          data-gtm-event-action="clique:como-instalar"
          data-gtm-event-label="caminhao"
        />
        <Option
          description={carType.bus}
          icon={<IcBus />}
          value="onibus"
          setOption={() => handleClickDownload(BusPDF)}
          notGray
          className="gtm-element-event"
          data-gtm-event-category="veloe:area-logado:identificadores"
          data-gtm-event-action="clique:como-instalar"
          data-gtm-event-label="onibus"
        />
      </List>
    </WrapperInstall>
  )
}

export default HowToInstall



// WEBPACK FOOTER //
// ./src/app/modules/HowToInstall/index.js